<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import SelectPanel from '@/comps-sdk/components/select-panel';
  import type { IZoneRoleSelect } from '@/comps-sdk/interface';

  import DefaultPanel from './default-panel.svelte';

  export let nullText: string = '';
  export let options: Array<any> = [];
  export let selectedValue: IZoneRoleSelect.PanelItem = {
    id: '',
    name: '',
  };

  const dispatch = createEventDispatcher();
  const handlePanelChange = (detail: IZoneRoleSelect.PanelItem) => {
    dispatch('select-change', detail);
  };
</script>

<div class={$$restProps.class || ''}>
  {#if options.length > 0}
    <SelectPanel
      {options}
      {selectedValue}
      on:change={(e) => {
        handlePanelChange(e.detail);
      }}
    />
  {:else}
    <DefaultPanel {nullText} />
  {/if}
</div>
